import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { getSpecificClients } from "views/clients/api/apiClients";
import { getDepreciationGroups, deleteDepreciationGroup, getDepreciationGroupById } from '../api/apiDepreciationGroup'
import CreateOrUpdateDepreciationGroup from "./CreateOrUpdateDepreciationGroup";
import ConfirmationDialog from "common/components/ConfirmationDialog";
import SelectClient from "common/components/custom/SelectClient";

class DepreciationGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            specificsClients: [],
            selectedClient: null,
            depreciationGroups: [],
            isOpen: false,
            depreciationGroupToEdit: null,
            depreciationGroupToDelete: null,
            dialogOpen: false,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getDepreciationGroups(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getDepreciationGroups(this.state.activePage, this.state.selectedClient.id))
    };

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getDepreciationGroups(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient , isLoading: false}, selectedClient ? this.getDepreciationGroups(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getDepreciationGroups = (page, selectedClient) => {
        getDepreciationGroups({ params: { page: page, size: this.state.rowsPerPage } }, selectedClient).then((response) => {
            this.setState({
                depreciationGroups: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getDepreciationGroups(page - 1, this.state.selectedClient));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getDepreciationGroupById = (id) => {
        getDepreciationGroupById(id).then(response => {
            this.setState({ depreciationGroupToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_depreciation_group_by_id"), { variant: 'error' });
        });
    }

    closeDialog = () => {
        this.setState({ isOpen: false, depreciationGroupToEdit: null });
    }

    deleteDepreciationGroup = () => {
        let { depreciationGroupToDelete } = this.state
        deleteDepreciationGroup(depreciationGroupToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_depreciation_group", { name: this.state.depreciationGroupToDelete.name }), { variant: 'success' });
            this.setState({ dialogOpen: false, depreciationGroupToDelete: null, rowsPerPage: this.state.rowsPerPage}, () => this.getDepreciationGroups(0, this.state.selectedClient.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_depreciation_group"), { variant: 'error' });
        });
    }

    render() {
        let { isLoading, specificsClients, selectedClient, depreciationGroups, isOpen, depreciationGroupToEdit, depreciationGroupToDelete, dialogOpen } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let depreciationGroupList;
        let recordsNotFound;
        if (depreciationGroups && depreciationGroups.length > 0) {
            depreciationGroupList = depreciationGroups.map((depreciationGroup, index) => {
                return <TableRow key={index}>
                    <TableCell>{depreciationGroup.accountGroup}</TableCell>
                    <TableCell>{depreciationGroup.name}</TableCell>
                    <TableCell>{depreciationGroup.description}</TableCell>
                    <TableCell>{depreciationGroup.regularRate}</TableCell>
                    <TableCell>{depreciationGroup.acceleratedRate}</TableCell>
                    <TableCell>{depreciationGroup.lifeSpanInYears}</TableCell>
                    <TableCell>{depreciationGroup.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getDepreciationGroupById(depreciationGroup.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ depreciationGroupToDelete: depreciationGroup, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={6} sm={6} md={4} lg={3} xl={3}>
                                <Grid container direction="row">
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                            {selectedClient !== null && <Grid item container direction="column" xs={6} sm={6} md={8} lg={9} xl={9} >
                                <Grid container direction="row" justifyContent="flex-end">
                                    <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ depreciationGroupToEdit: null, isOpen: true })}>
                                        {this.props.t("add_new_depreciation_group")}
                                    </Button>
                                </Grid>
                            </Grid>}
                        </Grid>

                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("account_group")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("description")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("regular_rate")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("accelerated_rate")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("life_span_in_years")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("active")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {depreciationGroupList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>

            </Grid>

            <CreateOrUpdateDepreciationGroup
                isOpen={isOpen}
                onClose={this.closeDialog}
                selectedClient={selectedClient}
                depreciationGroupToEdit={depreciationGroupToEdit ? depreciationGroupToEdit : null}
                getDepreciationGroups={() => this.getDepreciationGroups(this.state.activePage, selectedClient.id)}
            />
            {
                depreciationGroupToDelete && <ConfirmationDialog
                    isOpen={dialogOpen}
                    title={this.props.t("delete_depreciation_group")}
                    message={this.props.t("delete_dialog_message", { name: depreciationGroupToDelete.name })}
                    onClose={() => this.setState({ dialogOpen: false })}
                    onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteDepreciationGroup())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid >
    }
}

export default withSnackbar(withTranslation()(DepreciationGroup));